export const FETCH_MIS_ORDER_DATA="Fetch_Mis_Order_Data"
export const FETCH_MIS_ORDER_DATA_SUCCESS = "Fetch_Mis_Order_Data_Success";
export const FETCH_MIS_ORDER_DATA_FAILURE = 'Fetch_Mis_Order_Data_Failed';

export const fetchMisOrderData = (data) => {
    return {
        type: FETCH_MIS_ORDER_DATA,
        data
    }
}

export const fetchMisOrderDataSuccess = (data) => {
    return {
        type: FETCH_MIS_ORDER_DATA_SUCCESS,
        data
    }
}
export const fetchMisOrderDataFailure = (error) => {
    return {
        type: FETCH_MIS_ORDER_DATA_FAILURE,
        error
    }
}